export const enameledSkillet = {
  recipes: [
    {
      id: 'One-Pot Chicken & Gnocchi ',
      link: 'https://pamperedchef.widen.net/view/thumbnail/eoyieszx2h/post-recipe-one-pot-chicken-gnocchi-steps.jpg?position=c&color=ffffffff&quality=80&t.format=jpeg&x.share=t',
      img: {
        src: 'https://pamperedchef.widen.net/content/eoyieszx2h/jpeg/post-recipe-one-pot-chicken-gnocchi-steps.jpg?w=200&h=200&position=c&color=ffffffff&quality=80',
        alt: 'post-recipe-one-pot-chicken-gnocchi-steps.jpg',
      },
    },
    {
      id: 'Cauliflower Au Gratin',
      link: 'https://pamperedchef.widen.net/view/thumbnail/vpomqw7mz2/post-recipe-cauliflower-au-gratin-steps.jpg?position=c&color=ffffffff&quality=80&t.format=jpeg&x.share=t',
      img: {
        src: 'https://pamperedchef.widen.net/content/vpomqw7mz2/jpeg/post-recipe-cauliflower-au-gratin-steps.jpg?w=200&h=200&position=c&color=ffffffff&quality=80',
        alt: 'post-recipe-cauliflower-au-gratin-steps.jpg',
      },
    },
  ],
};
